export const Navbar = ({ activeSection, onNavigate }) => {
  const navItems = [
    { id: 'home',        label: 'HOME' },
    { id: 'about',       label: 'ABOUT' },
    { id: 'skills',      label: 'SKILLS' },
    { id: 'projects',    label: 'PROJECTS' },
    { id: 'experience',  label: 'XP' },
    { id: 'contact',     label: 'CONTACT' },
  ];

  return (
    <nav className="navbar">
      <div className="nav-container">
        <div className="logo" onClick={() => onNavigate('home')}>AG★</div>
        <ul className="nav-menu">
          {navItems.map((item) => (
            <li
              key={item.id}
              className={activeSection === item.id ? 'active' : ''}
              onClick={() => onNavigate(item.id)}
            >
              {item.label}
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
};
